import { restRequest } from "vrcore-dashboard/dist/utilities";

export const GET_VEHICLE_LIST = restRequest("VEHICLE_LIST.GET_VEHICLE_LIST");
export const SET_VEHICLE = restRequest("VEHICLE_LIST.SET_VEHICLE");

export const REMOVE_VEHICLE = restRequest("VEHICLE_LIST.REMOVE_VEHICLE");
export const GET_DEPARTMENTS = restRequest("VEHICLE_LIST.GET_DEPARTMENTS");
export const GET_AREAS = restRequest("VEHICLE_LIST.GET_AREAS");
export const UPLOAD_FILE = restRequest("VEHICLE_LIST.UPLOAD_FILE");
export const GET_CATEGORIES = restRequest("VEHICLE_LIST.GET_CATEGORIES")
export const ADD_CATEGORY = restRequest("VEHICLE_LIST.ADD_CATEGORY")
export const SET_FILTER_VEHICLE_TYPE = restRequest("VEHICLE_LIST.SET_FILTER_VEHICLE_TYPE")
export const GET_TEMPLATES = restRequest("VEHICLE_LIST.GET_TEMPLATES")
export const SET_ACTION = restRequest("VEHICLE_LIST.SET_ACTION")